<template>
  <div class="container page">
    <h1 class="title [ text-center ] [ py-3 ]">
      Richiesta cancellazione prenotazione
    </h1>
    <div class="row">
      <div class="col-12">
        <form @submit.prevent="attemptRegister">
          <div class="form-group">
            <input
              type="text"
              v-model="prenotazione.codice"
              name="codice"
              class="form-control"
              placeholder="Codice prenotazione"
              data-vv-as="nome"
              v-validate="{ required: true }"
              :class="errors.has('codice') ? 'is-invalid' : ''"
            />
            <small class="form-text text-danger">{{
              errors.first("codice")
            }}</small>
          </div>
          <div class="form-group">
            <input
              type="text"
              v-model="prenotazione.email"
              name="email"
              class="form-control"
              placeholder="Indirizzo Email"
              data-vv-as="email"
              v-validate="'required|email'"
              :class="errors.has('email') ? 'is-invalid' : ''"
            />
            <small class="form-text text-danger">{{
              errors.first("email")
            }}</small>
          </div>
          <div class="form-group [ text-center ]">
            <button type="submit" class="btn btn-primary btn-block">
              Cancella
            </button>
          </div>
          <div
            class="alert alert-danger [ text-center ]"
            v-if="errormessage != ''"
          >
            {{ errormessage }}
          </div>
        </form>
      </div>
    </div>
  </div>
</template>
<script>
// moment.locale('it')
export default {
  data () {
    return {
      errormessage: '',
      prenotazione: {
        codice: '',
        email: ''
      }
    }
  },
  components: {},
  computed: {},
  methods: {
    attemptRegister () {
      this.$validator.validateAll().then((isValid) => {
        if (isValid) {
          this.$store.dispatch(
            'event/removeenrollmentbycode',
            this.prenotazione
          )
        }
      })
    }
  },

  beforeRouteUpdate (to, from, next) {
    var me = this
    // react to route changes...
    // this.$store.dispatch('event/clearEvents');
    // don't forget to call next()
    next()
  },
  created () {
    var me = this
  }
}
</script>
